import { Box, TextField, MenuItem } from '@mui/material';
import CustomDatePicker from 'components/CustomDatePicker';
import FieldDisplay from 'components/FieldDisplay';


const GENDER_OPTIONS = ['Male', 'Female', 'Other'];
const MARITAL_OPTIONS = ['Single', 'Married', 'Divorced', 'Widowed'];

const GENDER_MAP = { ml: 'Male', m: 'Male', male: 'Male', fm: 'Female', f: 'Female', female: 'Female', other: 'Other' };
const normalizeGender = (v) => v ? (GENDER_MAP[v.toLowerCase()] ?? v) : '';
const normalizeMarital = (v) => {
  if (!v) return '';
  const lower = v.toLowerCase();
  const match = MARITAL_OPTIONS.find(o => o.toLowerCase() === lower);
  return match ?? (lower.charAt(0).toUpperCase() + lower.slice(1));
};


const PersonalInfo = ({
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  setFieldValue,
  isEditMode
}) => {

  if (!isEditMode) return (
    <Box
      display="grid"
      gridTemplateColumns="repeat(12, minmax(0, 1fr))"
      gap={2}
    >
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 3' } }}>
        <FieldDisplay label="Employee Code" value={values.employeeCode} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 6' } }}>
        <FieldDisplay label="Employee Name" value={values.employeeName} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 3' } }}>
        <FieldDisplay label="Short Name" value={values.shortName} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 3' } }}>
        <FieldDisplay label="Gender" value={normalizeGender(values.gender)} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 3' } }}>
        <FieldDisplay
          label="Date of Birth"
          value={values.birthday ? new Date(values.birthday).toLocaleDateString('en-GB') : null}
        />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 3' } }}>
        <FieldDisplay label="Place of Birth" value={values.placeOfBirth} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 3' } }}>
        <FieldDisplay label="Place of Origin" value={values.placeOfOrigin} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 3' } }}>
        <FieldDisplay label="Marital Status" value={normalizeMarital(values.marital)} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 3' } }}>
        <FieldDisplay label="Nationality" value={values.nationality} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 6' } }}>
        <FieldDisplay label="Location" value={values.location} />
      </Box>
    </Box>
  );


  return (
    <Box 
      display="grid" 
      gridTemplateColumns="repeat(12, minmax(0, 1fr))" 
      gap={2}
    >
      <TextField
        fullWidth
        size="small"
        label="Employee Code"
        name="employeeCode"
        value={values.employeeCode}
        onChange={handleChange}
        onBlur={handleBlur}
        error={touched.employeeCode && Boolean(errors.employeeCode)}
        helperText={touched.employeeCode && errors.employeeCode}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 3' } }}
      />
      
      <TextField
        fullWidth
        size="small"
        label="Employee Name"
        name="employeeName"
        value={values.employeeName}
        onChange={handleChange}
        onBlur={handleBlur}
        error={touched.employeeName && Boolean(errors.employeeName)}
        helperText={touched.employeeName && errors.employeeName}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 6' } }}
      />

      <TextField
        fullWidth
        size="small"
        label="Short Name"
        name="shortName"
        value={values.shortName}
        onChange={handleChange}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 3' } }}
      />

      <TextField
        fullWidth 
        select 
        size="small" 
        label="Gender" 
        name="gender"
        value={normalizeGender(values.gender)} 
        onChange={handleChange}
        slotProps={{ inputLabel: { shrink: true } }}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 3' } }}
      >
        {GENDER_OPTIONS.map(g => <MenuItem key={g} value={g}>{g}</MenuItem>)}
      </TextField>

      <TextField
        fullWidth 
        select 
        size="small" 
        label="Marital Status" 
        name="marital"
        value={normalizeMarital(values.marital)} 
        onChange={handleChange}
        slotProps={{ inputLabel: { shrink: true } }}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 3' } }}
      >
        {MARITAL_OPTIONS.map(m => <MenuItem key={m} value={m}>{m}</MenuItem>)}
      </TextField>
      <CustomDatePicker
        label="Date of Birth"
        name="birthday"
        value={values.birthday ? new Date(values.birthday) : null}
        onChange={setFieldValue}
        touched={touched}
        errors={errors}
        size="small"
        variant="outlined"
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 3' } }}
      />
      <TextField
        fullWidth 
        size="small" 
        label="Place of Birth" 
        name="placeOfBirth"
        value={values.placeOfBirth} 
        onChange={handleChange}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 3' } }}
      />
      <TextField
        fullWidth 
        size="small" 
        label="Place of Origin" 
        name="placeOfOrigin"
        value={values.placeOfOrigin} 
        onChange={handleChange}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 3' } }}
      />
      <TextField
        fullWidth 
        size="small" 
        label="Nationality" 
        name="nationality"
        value={values.nationality} 
        onChange={handleChange}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 3' } }}
      />
      <TextField
        fullWidth 
        size="small" 
        label="Location" 
        name="location"
        value={values.location} 
        onChange={handleChange}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 6' } }}
      />

    </Box>
  );
};

export default PersonalInfo;
